import React from 'react';

export interface IToastAction {
    label: string;
    onClick: () => void;
}

/**
 * Toast body with an optional follow-up link — "Added 12 products to Contoso Store / View
 * storefront products".
 *
 * The click handler is supplied by the dispatching component so navigation still goes through
 * react-router's history rather than a full page load. Capturing history in a closure is safe even
 * after that component unmounts: BrowserRouter's history is a singleton for the app's lifetime, and
 * these bulk operations deliberately outlive the screen that started them.
 */
export const toastBody = (message: string, action?: IToastAction): React.ReactNode => {
    if (!action) return message;

    return (
        <span>
            {message}
            <br/>
            <button
                type="button"
                onClick={action.onClick}
                style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    marginTop: 4,
                    // Toast backgrounds are type-colored, so inherit rather than pick a fixed color.
                    color: 'inherit',
                    font: 'inherit',
                    fontWeight: 600,
                    textDecoration: 'underline',
                    cursor: 'pointer',
                }}
            >
                {action.label}
            </button>
        </span>
    );
};

export default toastBody;
